<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mt-2 my-2">
      <div class="d-flex align-items-center">
        <span class="mr-2">{{ $t("paiement.filtrerParStatut") }}</span>
        <a-switch
          :checked="showDeletedClasses"
          :checked-children="$t('paiement.actives') || 'Actives'"
          :un-checked-children="$t('paiement.toutes') || 'Toutes'"
          @change="(v) => $emit('toggle-deleted', v)"
        />
      </div>
      <div class="d-flex align-items-center">
        <a-tag :color="allClassesConfirmed ? 'green' : 'red'" class="mr-2 mb-0">
          {{ confirmedClassesCount }} / {{ totalClassesCount }}
          {{ $t("inscription.enrollmentVisibleTag") }}
        </a-tag>
        <a-tooltip placement="left">
          <template slot="title">
            {{
              allClassesConfirmed
                ? $t("inscription.enrollmentAllVisibleTooltip")
                : $t("inscription.enrollmentAllHiddenTooltip")
            }}
          </template>
          <a-button
            :type="allClassesConfirmed ? 'default' : 'danger'"
            :class="allClassesConfirmed ? 'enrollment-availability-btn' : ''"
            :loading="confirmationLoading"
            :disabled="confirmationLoading || totalClassesCount === 0"
            @click="$emit('confirm-all')"
          >
            {{
              allClassesConfirmed
                ? $t("inscription.enrollmentVisibleTag")
                : $t("inscription.enrollmentHiddenTag")
            }}
          </a-button>
        </a-tooltip>
      </div>
    </div>
    <a-input-search
      :placeholder="$t('scolarite.charcherParClasse')"
      @keyup="(e) => $emit('search', e.target.value)"
    />
    <br />

    <a-empty
      v-if="isEmpty"
      :description="$t('scolarite.aucuneClasseTrouvee')"
      class="mt-4"
    />

    <a-directory-tree v-else default-expand-all @select="onSelect">
      <!-- classrooms without level -->
      <a-tree-node
        v-if="cache['undefined'] && cache['undefined'].length > 0"
        key="undefined-level"
        :title="$t('scolarite.other')"
      >
        <a-icon slot="icon" type="apartment" />
        <a-tree-node
          v-for="classroom in cache['undefined']"
          :key="classroom._id"
          is-leaf
        >
          <span slot="title">
            {{ classroom.name }}
            <a-tooltip>
              <template slot="title">
                {{
                  classroom.enrollmentConfirmed
                    ? $t("inscription.enrollmentVisibleTag")
                    : $t("inscription.enrollmentHiddenTag")
                }}
              </template>
              <a-icon
                type="eye"
                :style="{ color: '#52c41a', marginLeft: '6px' }"
                v-if="classroom.enrollmentConfirmed"
              />
              <a-icon
                type="eye-invisible"
                :style="{ color: '#f5222d', marginLeft: '6px' }"
                v-else
              />
            </a-tooltip>
          </span>
          <a-icon
            slot="icon"
            type="book"
            v-if="classroom.status === 'active'"
          />
          <a-icon slot="icon" type="book" class="text-danger" v-else />
        </a-tree-node>
      </a-tree-node>

      <!-- classrooms grouped by level -->
      <template v-for="(level, index) in levelLabels">
        <a-tree-node
          :key="index"
          v-if="cache[index] && cache[index].length > 0"
          :title="level"
        >
          <a-icon slot="icon" type="apartment" />
          <a-tree-node
            v-for="classroom in cache[index]"
            :key="classroom._id"
            is-leaf
          >
            <span slot="title">
              {{ classroom.name }}
              <a-tooltip>
                <template slot="title">
                  {{
                    classroom.enrollmentConfirmed
                      ? $t("inscription.enrollmentVisibleTag")
                      : $t("inscription.enrollmentHiddenTag")
                  }}
                </template>
                <a-icon
                  type="eye"
                  :style="{ color: '#52c41a', marginLeft: '6px' }"
                  v-if="classroom.enrollmentConfirmed"
                />
                <a-icon
                  type="eye-invisible"
                  :style="{ color: '#f5222d', marginLeft: '6px' }"
                  v-else
                />
              </a-tooltip>
            </span>
            <a-icon
              slot="icon"
              type="book"
              v-if="classroom.status === 'active'"
            />
            <a-icon slot="icon" type="book" class="text-danger" v-else />
          </a-tree-node>
        </a-tree-node>
      </template>
    </a-directory-tree>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ClassroomTree",
  props: {
    cache: { type: Object, default: () => ({}) },
    levelLabels: { type: Object, default: () => ({}) },
    showDeletedClasses: { type: Boolean, default: false },
    confirmedClassesCount: { type: Number, default: 0 },
    totalClassesCount: { type: Number, default: 0 },
    allClassesConfirmed: { type: Boolean, default: false },
    confirmationLoading: { type: Boolean, default: false },
  },
  computed: {
    isEmpty() {
      return !Object.values(this.cache || {}).some(
        (list) => Array.isArray(list) && list.length > 0
      );
    },
  },
  methods: {
    onSelect(keys) {
      this.$emit("select", keys[0]);
    },
  },
};
</script>

<style scoped>
.card >>> .ant-tree {
  font-size: 16px;
}
</style>
